import { useMemo } from 'react';
import format from 'xml-formatter';

const isParseError = parsedDocument => {
  const parser = new DOMParser();
  const erroneousParse = parser.parseFromString('<', 'text/xml');
  const parserErrorNS = erroneousParse.getElementsByTagName('parsererror')[0].namespaceURI;
  return parsedDocument.getElementsByTagNameNS(parserErrorNS, 'parsererror').length > 0;
};

const parseXml = xmlString => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(xmlString, 'text/xml');
  if (isParseError(dom)) {
    throw new Error('Error parsing XML');
  }

  return dom;
};

export const getParsedValueAndMode = (valueToParse, modeInput) => {
  let value;
  let mode;

  if (modeInput === 'application/text') {
    return { value: valueToParse, mode: modeInput };
  }

  try {
    value = JSON.stringify(JSON.parse(valueToParse), null, 2);
    mode = 'application/json';
  } catch {
    // Invalid JSON may still be valid XML or plain text.
    try {
      parseXml(valueToParse);
      value = format(valueToParse, { collapseContent: false, lineSeparator: '\n' });
      mode = 'application/xml';
    } catch {
      // Invalid XML is intentionally displayed as plain text.
      value = valueToParse;
      mode = 'application/text';
    }
  }

  return { value, mode };
};

export const useParsedValueAndMode = (valueToParse, mode) =>
  useMemo(() => getParsedValueAndMode(valueToParse, mode), [valueToParse, mode]);
